import qs from 'qs';
import axios from 'axios';
import { encrypt } from './crypto';
import { hasCode } from './special-errors';
import alertHasCode from './alert-errors';
import { HttpCacheMiddleware } from './http-axios-middleware';

const loading = (load) => {
    if (load) {
        let bodyClass = document.querySelector('body').getAttribute('class') || '';
        bodyClass = bodyClass.concat(' hidden-empty-style');
        document.querySelector('body').setAttribute('class', bodyClass);
        let tloadClass = document.querySelector('.topLoading').getAttribute('class');
        tloadClass = tloadClass.replace('vue-hidden', '');
        tloadClass = tloadClass.replace('hidden', '');
        document.querySelector('.topLoading').setAttribute('class', tloadClass);
    }
};
const clearLoaing = (load) => {
    if (load) {
        let bodyClass = document.querySelector('body').getAttribute('class');
        if (bodyClass) {
            bodyClass = bodyClass.replace('hidden-empty-style', '');
            document.querySelector('body').setAttribute('class', bodyClass);
        }
        // 清除动画报错
        if (!document.querySelector('.topLoading')) { return; }
        let tloadClass = document.querySelector('.topLoading').getAttribute('class');
        if (tloadClass.indexOf('vue-hidden') < 0) {
            tloadClass = tloadClass.concat(' vue-hidden');
            document.querySelector('.topLoading').setAttribute('class', tloadClass);
        }
    }
};
const errors = {
    401: (app, obj) => {
        const redirectToLogin = app.redirectToLogin || window.app.redirectToLogin;
        if (obj.errorCode) {
            app.$notify.error({ message: app.i18n.t(`lang.${obj.errorCode}`) });
            setTimeout(() => {
                redirectToLogin();
            }, 2000);
        } else {
            redirectToLogin();
        }
    },
    403: (app) => {
        app.$notify.error({ message: app.i18n.t('lang.1') });
    },
    422: (app, obj) => {
        let key;
        if (hasCode(obj.errorCode || '')) {
            window.location.href = `#/home/error-page/${obj.errorCode}`;
        } else if (alertHasCode(obj.errorCode || '')) {
            key = 'lang.2';
            if (obj.errorCode) {
                key = `lang.${obj.errorCode}`;
            }
            window.zxyDrizzle.message.alert(app.i18n.t(key));
        } else {
            key = 'lang.2';
            if (obj.errorCode) {
                key = `lang.${obj.errorCode}`;
            }
            app.$notify.error({ message: app.i18n.t(key) });
        }
    },
    500: (app) => {
        app.$notify.error({ message: app.i18n.t('lang.3') });
    }
};

const handleError = (app, status, obj) => {
    if (!errors[status]) return false;
    errors[status](app, obj);
    return true;
};

// eslint-disable-next-line
new HttpCacheMiddleware({
    isCache: false,
    isStorage: 'zxyStore',
    isExpired: 2 * 60
});
const encodeURIComponentFun = (config) => {
    /* 在axios中就会对get请求的整个url进行encodeURI，
    导致有些get方法不能传[]，所以在请求拦截器中可以对get方法单独处理，
    避开axios的encodeURI */
    const cfg = config;
    let url = cfg.url;
    // const keys = Object.keys(cfg.params);
    url += '?';
    // for (const key of keys) {
    //     if (cfg.params[key] || cfg.params[key] === 0) {
    //         url += `${key}=${encodeURIComponent(cfg.params[key])}&`;
    //     }
    // }
    Object.keys(cfg.params).forEach((key) => {
        if (cfg.params[key] || cfg.params[key] === 0) {
            url += `${key}=${encodeURIComponent(cfg.params[key])}&`;
        }
    });
    url = url.substring(0, url.length - 1);
    cfg.params = {};
    cfg.url = url;
    return cfg;
};
const initAjax = (http, app) => {
    axios.defaults.baseURL = 'api/v1/';
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    if (app.global.OAuth) {
        const tokenObj = app.global.OAuth.token;
        const auth = `${tokenObj.token_type}__${tokenObj.access_token}`;
        app.$http.defaults.headers.common.Authorization = auth;
    }
    // axios.defaults.headers.common.Authorization = 'Bearer__dfb042685f8797a64f980e2754884f86';
    axios.defaults.headers.common.Version = '10.7.0';
    // 请求拦截器
    axios.interceptors.request.use((config) => {
        const cfg = config;
        if (cfg.loading) {
            loading(cfg.loading);
        }
        if (cfg.security && cfg.data) {
            const result = {};
            Object.keys(cfg.data).forEach((key) => {
                result[key] = encrypt(cfg.data[key]);
            });
            cfg.data = result;
        }
        if (cfg.method === 'post') {
            if (cfg.encode) {
                cfg.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
                cfg.data = qs.stringify(cfg.data);
            }
        } else if (cfg.method === 'put') {
            if (cfg.encode) {
                cfg.headers.put['Content-Type'] = 'application/x-www-form-urlencoded';
                cfg.data = qs.stringify(cfg.data);
            }
        } else if (cfg.method === 'get') {
            if (cfg.params) {
                const newConfig = encodeURIComponentFun(cfg);
                cfg.params = Object.assign(newConfig.params, { '_=': new Date().getTime() }); // 防止缓存
                // cfg.params = Object.assign(cfg.params, { '_=': new Date().getTime() }); // 防止缓存
            } else {
                cfg.params = { '_=': new Date().getTime() };
            }
        }
        return cfg;
    }, (error) => {
        // app.$loading.hide();
        clearLoaing(true);
        return Promise.reject(error);
    });
    // 响应拦截器
    axios.interceptors.response.use((response) => {
        const data = response;
        clearLoaing(true);
        return data;
    }, (error) => {
        clearLoaing(true);
        handleError(app, error.response.status, error.response.data);
        const reject = Promise.reject(error);
        return reject;
    });
};


export { initAjax as default };
